import React from 'react';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Typography, Icon } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus, faPlus, faSlashForward } from '@fortawesome/pro-regular-svg-icons';

const t = (key) => translate('ui', key);

const renderValue = (value: number | undefined | null) => {
  switch (value) {
    case null:
      return (
        <span style={{ color: '#0c72b7' }}>
          <Icon>
            <FontAwesomeIcon icon={faSlashForward} />
          </Icon>
        </span>
      );
    case 1:
      return (
        <span style={{ color: '#e86825' }}>
          <Icon>
            <FontAwesomeIcon icon={faMinus} />
          </Icon>
        </span>
      );
    case 2:
      return (
        <span style={{ color: '#6c820c' }}>
          <Icon>
            <FontAwesomeIcon icon={faCheck} />
          </Icon>
        </span>
      );
    case 3:
      return (
        <span style={{ color: '#098e51' }}>
          <Icon>
            <FontAwesomeIcon icon={faCheck} />
          </Icon>
          <Icon>
            <FontAwesomeIcon icon={faPlus} />
          </Icon>
        </span>
      );
    default:
      return <>?</>;
  }
};

type AssessmentScoreProps = {
  score?: number | null | undefined;
  showLabel?: boolean;
};

const AssessmentScore: React.FC<AssessmentScoreProps> = (props: AssessmentScoreProps) => {
  const classes = useStyles();
  return (
    <div className={classes.dFlex}>
      {renderValue(props.score)}
      <Typography variant="body1" className={classes.pl2}>
        {props.showLabel && props.score !== undefined && t('likert.' + props.score)}
      </Typography>
    </div>
  );
};

export default AssessmentScore;

const useStyles = makeStyles((theme: Theme) => {
  return {
    dFlex: {
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'row wrap',
    },
    pl2: {
      paddingLeft: theme.spacing(2),
    },
  };
});
